<template>
    <div class="main">
        <c-panel>
            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="hidden-mobile" style="width: 70px;">cod</th>
                            <th>Data</th>
                            <th>Turma</th>
                            <th>Horário</th>
                            <th style="width: 150px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id">
                            <td class="hidden-mobile">{{ item.id }}</td>
                            <td>{{ $moment(item.data).format('DD/MM/YYYY') }}</td>
                            <td>{{ `${item.turma.curso.nome} - ${item.turma.nome}` }}</td>
                            <td>{{ item.horario }}º horário</td>
                            <td class="u-text-center acao"> 
                                <el-button @click="openConflito(item.id)" type="info" title="Editar" icon="el-icon-s-help" size="mini" plain></el-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12" :md="12">
                        <div class="u-text-left u-mt-10">
                            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                                <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                            </div>
                    </el-col>
                </el-row>
            </div>
        </c-panel>
    </div>
</template>
<script>

export default {
    data: () => ({
        statusList: false,
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: [ ]
    }),
    mounted () {
      this.loadingConflitos()
    },
    methods: {
        loadingConflitos(){

            this.statusList = false;
            this.items = [];

            let i = this.$store.state.config.instituicao.id;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/frequencia/getConflitosAllPaginate/${i}?page=` + this.paginate.page, {}, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingConflitos();
        },
        openConflito(item){

            this.$router.push(`/admin/diario/conflitos-frequencia/edit/${item}`);
        }
    },
    components:{  }
}
</script>